import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { X, Gift, ArrowRight, Sparkles } from 'lucide-react';

const ReferralBanner = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // LocalStorage'dan dismiss durumunu kontrol et
    const dismissed = localStorage.getItem('referral_banner_dismissed');
    const dismissedAt = localStorage.getItem('referral_banner_dismissed_at');
    
    // 7 gün sonra tekrar göster
    if (dismissed && dismissedAt) {
      const dismissedDate = new Date(dismissedAt);
      const now = new Date();
      const daysDiff = (now - dismissedDate) / (1000 * 60 * 60 * 24);
      
      if (daysDiff < 7) {
        setIsDismissed(true);
        return;
      }
    }
    
    // Küçük bir gecikme ile göster (sayfa yüklendikten sonra)
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsVisible(false);
    setIsDismissed(true);
    localStorage.setItem('referral_banner_dismissed', 'true');
    localStorage.setItem('referral_banner_dismissed_at', new Date().toISOString());
  };

  const handleClick = () => {
    if (user) {
      navigate('/referans');
    } else {
      navigate('/referans-programi');
    }
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div 
      onClick={handleClick}
      className="relative bg-gradient-to-r from-primary/90 via-emerald-500/90 to-teal-500/90 cursor-pointer group overflow-hidden"
      data-testid="referral-banner"
    >
      {/* Animated background */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAgTSAwIDIwIEwgNDAgMjAgTSAyMCAwIEwgMjAgNDAgTSAwIDMwIEwgNDAgMzAgTSAzMCAwIEwgMzAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-50" />
      
      {/* Sparkle effects */}
      <div className="absolute top-1 left-[10%] animate-pulse">
        <Sparkles className="h-3 w-3 text-white/40" />
      </div>
      <div className="absolute top-2 right-[20%] animate-pulse delay-300">
        <Sparkles className="h-2 w-2 text-white/30" />
      </div>
      
      <div className="container mx-auto px-4 py-2.5 relative">
        <div className="flex items-center justify-center gap-3 text-white">
          {/* Icon */}
          <div className="flex items-center justify-center bg-white/20 rounded-full p-1.5 group-hover:scale-110 transition-transform">
            <Gift className="h-4 w-4" />
          </div>
          
          {/* Text */}
          <div className="flex items-center gap-2 text-sm font-medium">
            <span className="hidden sm:inline">🎁</span>
            <span>
              <span className="font-bold">Arkadaşını davet et, birlikte kazanın!</span>
              <span className="hidden md:inline text-white/90"> — Sen %20 kredi, arkadaşın %15 indirim</span>
            </span>
          </div>
          
          {/* CTA */}
          <div className="flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full text-xs font-semibold transition-colors">
            <span>Detaylar</span>
            <ArrowRight className="h-3 w-3 group-hover:translate-x-0.5 transition-transform" />
          </div>
        </div>
      </div>
      
      {/* Close button */}
      <button
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Kapat"
      >
        <X className="h-4 w-4 text-white/70 hover:text-white" />
      </button>
    </div>
  );
};

export default ReferralBanner;
